module.exports = __webpack_public_path__ + "static/media/baseball-ball.e1169a7e.svg";